import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  idFrom:"",
  idTo:"",
  defaultStoreIdFrom:"",
  defaultStoreIdTo:"",
  useraccountIdFrom:"",
  useraccountIdTo:"",
  numberSheetFrom:"",
  numberSheetTo:"",
  dateSheetFrom:null,
  dateSheetTo:null,
  marcaFrom:"",
  marcaTo:"",
  modeloFrom:"",
  modeloTo:"",
  licensePlateSheetFrom:"",
  licensePlateSheetTo:"",
  frameSheetFrom:"",
  frameSheetTo:"",
  sheetStateFromES:"",
  sheetStateToES:"",
  sheetStateFromEN:"",
  sheetStateToEN:"",
  isFinished:false,
  isPending:true
};

const filtersSHEETSlice = createSlice({
  name: 'filtersSHEET',
  initialState,
  reducers: {
    setFilters(state, action) {
      return { ...state, ...action.payload };
    },
    resetFilters() {
      return initialState;
    },
  },
});

export const { setFilters, resetFilters } = filtersSHEETSlice.actions;
export default filtersSHEETSlice.reducer;
